import * as Constants from "../../utils/constants";

export const tenderAction = (
    query: any,
    isHideLoader = false,
    callback?: Function
  ) => ({
    type: Constants.ACCEPT_DECLINE_LOADS,
    payload: { query, isHideLoader},
    callback
  });

  export const acceptLoadData = (data: any) => ({
    type: Constants.ACCEPT_LOAD_DATA,
    payload: { data },
  });

  export const declineLoadData = (data: any) => ({
    type: Constants.DECLINE_LOAD_DATA,
    payload: { data },
  });

  export const addReference = (
    query: any,
    isHideLoader = false,
    callback?: Function
    ) => ({
    type: Constants.ADD_REFERENCE,
    payload: { query, isHideLoader },
    callback
  });

  export const addReferenceData = (data: any) => ({
    type: Constants.ADD_REFERENCE_DATA,
    payload: { data },
  });

  export const pcMillerRequest = (payload: any, callback?: Function) => ({
    type: Constants.PCMILLER_REQUEST,
    payload,
    callback
  });

  export const pcMillerData = (data: any) => ({
    type: Constants.PCMILLER_DATA,
    payload: { data }
  });